
// ドロワーメニュー

export const init = () => {
    jQuery(function($){
        if ($("#toggle").length > 0) {
            $("#toggle").click(function () {
    
                $(this).toggleClass("toggle_active");
                $("#drawer_layer").fadeToggle();
                $("body").toggleClass("drawer_open");
    
                if ($(this).hasClass("toggle_active")) {
                    $("nav").addClass("is_open");
                    $("nav").removeClass("is_close");
                } else {
                    $("nav").removeClass("is_open");
                    $("nav").addClass("is_close");
                }
            });
    
            $("#drawer_layer").click(function () {
                $(this).fadeOut();
                $("#toggle").removeClass("toggle_active");
                $("body").removeClass("drawer_open");
                $("nav").removeClass("is_open");
                $("nav").addClass("is_close");
            });
            // エリア内リンク用
            $("nav a").on("click", function () {
                // if (window.innerWidth <= 768) {
                if ($("#toggle:visible").length > 0) {
                    $("#toggle").click();
                }
            });
        }
    })
};
export default init;
